export class QueryParams {
  private static params: URLSearchParams = new URLSearchParams(window.location.search);

  static get(param: string): string | null {
    return this.params.get(param);
  }

  static getBoolean(param: string): boolean {
    const v = this.get(param);
    return v === 'true';
  }

  static get devMode(): string | null {
    return this.get('devMode');
  }

  static get skipAuth(): boolean {
    return this.getBoolean('skipAuth');
  }

  static get lng(): string | null {
    return this.get('lng');
  }

  static get tenantId(): string | null {
    return this.get('tenantId');
  }

  static get sessionId(): string | null {
    return this.get('sessionId');
  }

  static get mockST(): boolean {
    return this.getBoolean('mockST');
  }

  static get leftConnector(): string | null {
    return this.get('leftConnector');
  }

  static get useCreoConnector(): boolean {
    return this.leftConnector === 'creo';
  }
}

export default QueryParams;
